// @flow
import { upperFirst } from "lodash"

export default (string: string) => upperFirst(string.replace("_", " "))
